import { t } from 'i18next';

export type OntologyValuesType = {
  ontologyType: string | undefined;
  phrase: string | undefined;
  abbreviation: string | undefined;
  definition: string | undefined;
};
export interface Item {
  id: string;
  ontologyType: number | undefined;
  phrase: string;
  abbreviation: string;
  definition: string;
}

export interface OntologyPropsType {}

export const collapse = {
  marginLeft: -15,
} as React.CSSProperties;

export const deleteConfirmTitles = () => ({
  title: t('general.deleteConfirmTitle'),
  okText: t('general.no'),
  cancelText: t('general.yes'),
});

export const predefinedOntologies = [
  'Admin',
  'Strategic Objectives',
  'Political Objectives',
  'Operational Objectives',
  'Exercise Objectives',
  'Training Objectives',
  'End State',
  'Strategic Objective',
  'Political Objective',
  'Operational Objective',
  'Exercise Objective',
  'Training Objective',
];
